import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { db } from "../Firebase";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaDumbbell, FaAppleAlt, FaChartLine, FaCalendarAlt, FaCheckCircle, FaWhatsapp } from "react-icons/fa";

export default function ProgramDetails() {

    const [program, setProgram] = useState(null);

    const location = useLocation();

    const id = new URLSearchParams(location.search).get("id");

    useEffect(() => {

        if (id) {

            db.collection("programs")
                .doc(id)
                .get()
                .then((doc) => {

                    if (doc.exists) {

                        setProgram({
                            id: doc.id,
                            ...doc.data()
                        });

                    }

                });

        }

    }, [id]);

    if (!program) {
        return <h2 className="text-center py-5">Loading...</h2>;
    }

    return (
        <>
            <title>Program Details | The Fitness Expert | Online Fitness Coach</title>
            <meta name="description" content="Learn more about our personalized fitness coaching programs. Explore program duration, features, benefits, nutrition guidance, and expert support from The Fitness Expert." />
            <meta name="keywords" content="fitness program, online coaching, fat loss program, muscle building, body recomposition, nutrition coaching, personalized workout plan, fitness transformation, online personal trainer, The Fitness Expert" />
            <meta property="og:title" content="Fitness Program Details | The Fitness Expert" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content={`https://thefitnessexpert.in/user/ProgramDetails?id=${program.id}`} />
            <meta property="og:description" content="Discover detailed information about our personalized fitness coaching programs including workout plans, nutrition guidance, progress tracking, and expert support." />
            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Discover detailed information about our personalized fitness coaching programs including workout plans, nutrition guidance, progress tracking, and expert support." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="bg-dark text-white py-5">
                <div className="container">
                    <div className="row align-items-center gap-5">
                        <div className="col-lg-5">
                            <span className="badge bg-danger mb-3">TRANSFORMATION PROGRAM</span>
                            <h1 className="display-3 fw-bold">{program.icon} {program.name}</h1>
                            <p className="lead my-4">{program.desc}</p>
                            <div className="d-flex gap-3 flex-wrap">
                                <div className="bg-black p-3 rounded">
                                    <small>Duration</small>
                                    <h5>{program.duration}</h5>
                                </div>
                                <div className="bg-black p-3 rounded">
                                    <small>Level</small>
                                    <h5>All Levels</h5>
                                </div>
                            </div>
                            <div className="mt-4">
                                <Link to="/user/Contact">
                                    <button className="btn btn-danger me-3">Enroll Now</button>
                                </Link>
                                <button className="btn btn-outline-light">Free Consultation</button>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center">
                            <img src={program.img} alt="" className="img-fluid rounded-4 shadow" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row align-items-stretch g-4">
                        <div className="col-lg-7">
                            <div className="h-100 p-4 bg-light rounded-4 shadow-sm">
                                <span className="text-danger fw-bold text-uppercase">What's Included</span>
                                <h2 className="fw-bold mb-4">Everything You Need To Achieve Results</h2>
                                <div className="row g-3">
                                    {program.features?.map((feature, index) => (
                                        <div className="col-md-12" key={index}>
                                            <div className="feature-card">
                                                <div className="feature-icon"><FaCheckCircle /></div>
                                                <h6 className="fw-bold mb-1">
                                                    {feature}
                                                </h6>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 p-3">
                            <div className="program-info-card h-100">
                                <h3 className="fw-bold mb-4">Program Details</h3>
                                <div className="info-row">
                                    <span>⏳ Duration</span>
                                    <strong>{program.duration}</strong>
                                </div>
                                <div className="info-row">
                                    <span>🏋️ Availability / Week</span>
                                    <strong>Mon-Sat</strong>
                                </div>
                                <div className="info-row">
                                    <span>📞 Coach Support</span>
                                    <strong>10AM - 7PM</strong>
                                </div>
                                <div className="info-row">
                                    <span>📈 Progress Tracking</span>
                                    <strong>Weekly</strong>
                                </div>
                                <div className="info-row">
                                    <span>🎯 Training Level</span>
                                    <strong>All Levels</strong>
                                </div>
                                <div className="info-row">
                                    <span>📍 Mode</span>
                                    <strong>Online</strong>
                                </div>
                                <hr />
                                <Link to="/user/Contact">
                                    <button className="btn btn-danger w-100 py-3 fw-bold">
                                        Enroll Now
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-5">Your Journey Step By Step</h2>
                    <div className="row text-center">
                        {["Assessment", "Custom Plan", "Training", "Progress Tracking", "Results"].map((step, index) => (
                            <div className="col-lg-2 col-md-4 col-6 mx-auto" key={index}>
                                <div className="p-3">
                                    <div className="bg-danger text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center journeyy">
                                        {index + 1}
                                    </div>
                                    <h6>{step}</h6>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div >
            <Footer />
        </>
    );
}